import React from 'react'

export function Checker() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0"
            y="0"
            enableBackground="new 0 0 511.999 511.999"
            version="1.1"
            viewBox="0 0 511.999 511.999"
            xmlSpace="preserve"
        >
            <path
                fill="#B3404A"
                d="M210.316 441.388c-18.455 0-35.807-7.187-48.857-20.236-5.261-5.261-5.261-13.791 0-19.053 5.261-5.259 13.791-5.259 19.053 0 7.961 7.962 18.547 12.346 29.805 12.346s21.843-4.384 29.805-12.346l232.62-232.619c7.962-7.961 12.346-18.547 12.346-29.805s-4.384-21.843-12.346-29.804c-16.436-16.437-43.176-16.436-59.609-.001L283.532 239.471c-5.262 5.259-13.79 5.259-19.053 0-5.261-5.261-5.261-13.791 0-19.053L394.08 90.815c26.94-26.937 70.772-26.94 97.715 0 26.94 26.941 26.94 70.776 0 97.716l-232.62 232.621c-13.05 13.05-30.402 20.236-48.859 20.236z"
            ></path>
            <path
                fill="#F4B2B0"
                d="M287.978 371.291l-39.331 39.331c-21.722 21.722-56.94 21.722-78.662 0L29.731 270.37c-21.722-21.722-21.722-56.94 0-78.662 21.722-21.722 56.94-21.722 78.662 0l179.585 179.583z"
            ></path>
            <path
                fill="#B3404A"
                d="M209.315 440.386c-18.457 0-35.807-7.187-48.857-20.236L20.205 279.896c-26.94-26.941-26.94-70.775 0-97.716 13.052-13.05 30.402-20.236 48.857-20.236 18.457 0 35.807 7.187 48.857 20.236l179.585 179.585c5.261 5.261 5.261 13.791 0 19.053l-39.331 39.331c-13.052 13.049-30.402 20.237-48.858 20.237zM69.062 188.888c-11.258 0-21.843 4.384-29.805 12.346-16.434 16.434-16.434 43.176 0 59.611L179.51 401.096c7.961 7.962 18.545 12.346 29.805 12.346 11.258 0 21.843-4.384 29.805-12.346l29.805-29.805L98.866 201.234c-7.961-7.962-18.545-12.346-29.804-12.346z"
            ></path>
        </svg>
    );
}
